/**
 * La part remplie d'un curseur (`Ui::RangeComponent`) : la piste se peint jusqu'à `--fill`,
 * la position de la valeur entre les bornes. Le serveur pose la première, ceci les suivantes —
 * à chaque mouvement (contrôleur `range`) ou quand un hôte règle la valeur lui-même.
 */
export function paintRangeFill(range: HTMLInputElement): void {
  const min = Number(range.min) || 0;
  const max = range.max === "" ? 100 : Number(range.max);
  const ratio = max > min ? (Number(range.value) - min) / (max - min) : 0;
  range.style.setProperty("--fill", `${Math.round(Math.max(0, Math.min(1, ratio)) * 1000) / 10}%`);
}
